export default __webpack_public_path__ + "static/media/al-razi.945f314c.jpg";